import { render } from "./EventFormFooter.vue?vue&type=template&id=70394744&scoped=true"
import script from "./EventFormFooter.vue?vue&type=script&lang=ts"
export * from "./EventFormFooter.vue?vue&type=script&lang=ts"

import "./EventFormFooter.vue?vue&type=style&index=0&id=70394744&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70394744"

export default script